import { useState, useEffect } from 'react';
import DataTable from 'react-data-table-component';
import { CustomPagination } from '../../../components/common/table-pagination/CustomPagination';
import logger from '../../../utils/logger';
import { motion } from 'framer-motion';
import { LoadingComponent } from '../../common/LoadingComponent/LoadingComponent';
import { getStateInfo } from '../../../helper/stateTranslate';
import { CircleStatusComponent } from '../../common/CircleStatusSpan/CircleStatusComponent';
import { UseSettingColumns } from '../../../hooks/DataTable-hooks/useVisibleCols';
import { Link } from 'react-router-dom';
import { phoneNumberFormat } from '../../../helper/phoneNumberFormat';
import { ActionsOnUsers } from '../../dashboard/subContent/dataTable/ActionsOnUsers';
import ReactBootstrapModal from '../../common/modals/ReactBootstrapModal';
import { CustomAlert } from '../../common/Alerts/CustomAlert';
import './deliveryDataTable.css'
import { EmptyDataComponent } from '../../common/EmptyData/EmptyDataComponent';
import { DeliveryActions } from './DeliveryActions';
import { UserDetailModal } from '../../common/userDetailModal/UserDetailModal'
import { UseGetMemberById } from '../../../hooks/DataTable-hooks/UseGetMemberById';
import { useSelector } from 'react-redux';



export const DeliveryDataTable = ({ actionPack, memberShip, alert, usersData, handleObject, loading, currentPagination, stateModel }) => {

    logger.debug('DeliveryDataTable usersData: ', usersData)



    const prefixNumber = useSelector((data) => data?.commonData?.lista?.cellphonePrefixes)

    const getPrefix = (id) => {

        logger.debug('getPrefix: ', id)

        const prefix = prefixNumber?.find(u => u.id === id)

        logger.debug('prefix: ', prefix)

        return prefix?.prefix
    }


    

    //?Manejo de la Paginacion con la Api
    logger.info('currentPagination: ', currentPagination)

    const [customObjet, setCustomObjet] = useState({
        PageSize: currentPagination.PageSize,
        PageIndex: currentPagination.PageIndex
    })

    useEffect(() => {
        setCustomObjet({
            PageSize: currentPagination.PageSize,
            PageIndex: currentPagination.PageIndex
        })
    }, [currentPagination])


    const handleChangePage = (newPage) => {
        console.log('newPage: ', newPage)
        const nuevoObjeto = {
            ...customObjet,
            PageIndex: newPage
        };
        setCustomObjet(nuevoObjeto);
        handleObject(nuevoObjeto)

    }

    logger.info('customObjet: ', customObjet)


    const handleChangeRowsPerPage = (newPageSize) => {
        const totalItems = usersData.totalFiltered || 0
        const globalIndex = (customObjet.PageIndex - 1) * customObjet.PageSize + 1
        const newPage = Math.ceil(globalIndex / newPageSize);


        const nuevoObjeto = {
            PageSize: newPageSize,
            PageIndex: newPage
        }
        setCustomObjet({
            PageSize: newPageSize,
            PageIndex: newPage
        })
        handleObject(nuevoObjeto)
    }
    //? Obtiene la Informacion de un usuario en especifico para el contenido del Modal MEMBERSHIP
    const { memberDataById, handleMemberId } = UseGetMemberById()


    //? Setea la cantidad de columnas visibles segun el ancho de la pantalla
    const { visibleCols } = UseSettingColumns()

    const [bootstrapModalStatus, setBootstrapModalStatus] = useState(null);

    const showBootstrapModal = (id) => {
        setBootstrapModalStatus(id);
    }

    logger.debug('bootstrapModalStatus', bootstrapModalStatus)
    //? Setea el contenido del Modal de Alert 

    const [customAlertContent, setCustomAlertContent] = useState(null)

    const handleAlertContent = (buttonParams) => {
        setCustomAlertContent(buttonParams)
    }

    logger.debug('customAlertContent', customAlertContent)
    //? Accion para cerrar los Modals (ALERT o MEMBERSHIP)

    const closeBootstrapModal = () => {
        setBootstrapModalStatus(null);
    }

    // const [currentPage, setCurrentPage] = useState(null);

    // const handlePageChange = (page) => {

    //     logger.info('page:', page)
    //     setCurrentPage(page);

    // };

    // const [onreached, setOnReached] = useState(second)
    const handleCheckboxChange = (row, checked) => {
        // logger.info('Usuario:', row, 'Checked:', checked);
    };


    const allColumns = [
        {
            name: 'Nombre',
            selector: row => `${row.member.lastname} ${row.member.name}`,
            cell: row => (
                (row.member.name && row.member.lastname ?

                    <CircleStatusComponent
                        isVisible={visibleCols <= 5}
                        lastname={row.member.lastname}
                        name={row.member.name}
                        state={cssClassFromState(row.status, row.pickup)}
                    />
                    : null
                )

            ),

        },
        {
            name: 'Teléfono',
            cell: row => (
                <Link

                    to={`https://wa.me/${phoneNumberFormat(row.member.phoneNumber, getPrefix(row.member?.phonePrefixId))}`}
                    target='blank'
                    className=" text-truncate d-inline-block w-100"
                // style={{ maxWidth: '150px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
                >
                    {row.member.phoneNumber &&
                        phoneNumberFormat(row.member.phoneNumber, getPrefix(row.member?.phonePrefixId), true)
                    }

                </Link>
            ),
        },
        {
            name: 'DNI',
            selector: row => row.member.dni,
            sortable: true,
        },
        {
            name: 'Email',
            selector: row => row.member.email,

        },
        {
            name: 'Estado',

            //? Realiza un efecto map de estados segun el estado mismo que posea el usuario
            cell: row => (
                row.status &&
                <span className={`span-status span-${cssClassFromState(row.status, row.pickup)}`}>
                    {/* {row.state} */}

                    {stateToTranslate(row.status, row.pickup)}
                </span>
            ),
            sortable: true,
        },
        {
            name: 'Provincia',
            selector: row => row.province,

        },
        {
            name: 'Ciudad',
            selector: row => row.city,

        },
        {
            name: 'Direccion',
            selector: row => row.address,

        },
        {
            name: 'CP',
            selector: row => row.zipCode,

        },
        {
            name: 'Acciones',
            cell: row => (
                <div className="acciones d-flex">

                    <DeliveryActions
                        actionPack={actionPack}
                        status={row.status}
                        row={row}
                        handleModal={showBootstrapModal}
                        alert={alert}
                        memberShip={memberShip}
                        handleAlertContent={handleAlertContent}
                        handleMemberId={handleMemberId}
                    />


                </div>
            ),
        },
    ];

    const columns = allColumns.slice(0, visibleCols); // Seleccionar solo las columnas visibles
    const hiddenColumns = allColumns.slice(visibleCols); // Obtener las columnas ocultas
    const maxHeightScroll = `${window.innerHeight}px`;
    logger.info('columns: ', columns, 'hiddenColumns: ', hiddenColumns)

    //? Componente expandible para las filas que muestra las columnas ocultas
    const ExpandedComponent = ({ data }) => (
        <div style={{ padding: '10px', background: '#f9f9f9' }}>
            {hiddenColumns.length === 0 ? (
                <i>No hay más datos ocultos.</i>
            ) : (
                <table>
                    <tbody>
                        {hiddenColumns.map((col, index) => (
                            <tr key={index}>
                                <td style={{ fontWeight: 'bold', paddingRight: 10 }}>{col.name}:</td>
                                <td>
                                    {col.selector
                                        ? col.selector(data)
                                        : col.cell
                                            ? col.cell(data)
                                            : '-'}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}
            {/* Mostrar acciones en la fila expandida */}
            {visibleCols < 7 ? null : <div className="acciones">
                {/* <button className="btn toTooltip" title="Rechazar">
                    <span className="material-icons mI-table">cancel</span>
                </button>
                <button className="btn toTooltip" title="Reenviar">
                    <span className="material-icons mI-table">forward_to_inbox</span>
                </button>
                <a href="#" className="btn btn-user-info" title="Info">
                    <span className="material-icons mI-table">visibility</span>
                </a> */}
            </div>}

        </div>
    );


    //? Traduccion de estados 



    const stateToTranslate = (state, pickup) => {
        if (usersData.items) {

            //! Si Status == "Sent" && pickUp == true => Estado "Entregado"
            if (state === 'Sent' && pickup === true) {
                const getState = getStateInfo(stateModel, 'Delivered')
                return getState.stateString
            }

            else if (state === 'Pending' && pickup === true) {

                const getState = getStateInfo(stateModel, 'Withdrawal')
                return getState.stateString

            }
            else {





                const getState = getStateInfo(stateModel, state)
                logger.info('status translationStatus: ', getState)

                return getState.stateString
            }
        }
    }

    const cssClassFromState = (state, pickup) => {
        if (usersData.items) {


            //! Si Status == "Sent" && pickUp == true => Estado "Entregado"
            if (state === 'Sent' && pickup === true) {
                const getState = getStateInfo(stateModel, 'Delivered')
                return getState.cssClass


                //! Si Status == "Pending" && pickUp == true => Estado "Retiro"

            } else if (state === 'Pending' && pickup === true) {

                const getState = getStateInfo(stateModel, 'Withdrawal')
                return getState.cssClass

            } else {





                const getState = getStateInfo(stateModel, state)
                logger.info('status translationStatus: ', getState)

                return getState.cssClass
            }
        }
    }

    return (
        <motion.div
            className="dataTableStyle react-dataTable-Style"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.8 }}
        >
            <DataTable
                title="Usuarios"
                columns={columns}
                data={usersData.items}
                responsive
                highlightOnHover
                striped
                noHeader
                expandableRows={hiddenColumns.length > 0} // Solo permite expandir si hay columnas ocultas
                expandableRowsComponent={ExpandedComponent} // Componente que se muestra al expandir
               
                //? evita el scroll de la tabla
                // fixedHeader
                // fixedHeaderScrollHeight={maxHeightScroll}
                
                //? propiedad para cuando el array esta vacio 
                noDataComponent={
                    <EmptyDataComponent />
                }

                pagination
                paginationServer
                paginationPerPage={customObjet.PageSize}
                paginationTotalRows={usersData.totalFiltered || 0}
                paginationDefaultPage={customObjet.PageIndex}
                onChangePage={handleChangePage}
                onChangeRowsPerPage={handleChangeRowsPerPage}
                paginationComponent={CustomPagination}

                // paginationPerPage={10}
                paginationRowsPerPageOptions={[10, 25, 50]}


                customStyles={{
                    cells: {
                        style: {
                            padding: '8px', // Ajustar el padding de las celdas
                        },
                    },
                }}
                conditionalRowStyles={[
                    {
                        when: row => true, // o cualquier condición
                        classNames: ['row-style'],
                    },
                ]}

                //! Hace ferencia a la fila clickeada y muestra por consola los datos, util para obtener el id del usuario
                onRowClicked={(row) => {
                    // logger.info('ID del usuario clickeado:', row.id) // 👈 incluso si no lo mostrás

                    logger.info('ID del usuario clickeado:', row.id)

                    if (memberShip) {

                        showBootstrapModal('info')
                        handleMemberId(row.member?.id)
                    }


                }}

                //! LOADING
                progressPending={loading} // 👉cuando true muestra loader
                // progressComponent={<div>Cargando usuarios...</div>}
                progressComponent={<LoadingComponent />}
            // progressComponent={<SkeletonLoader/>}

            />
            <ReactBootstrapModal
                toggleModal={closeBootstrapModal}
                showModal={bootstrapModalStatus}
                modalClass={bootstrapModalStatus === 'alert' ? 'modalAlert' : 'fc-modalInfo'}
                dialogClass={'formation-dialogClass'}
            >


                {bootstrapModalStatus === 'info' ?
                    // <MembershipInfo
                    //     toggleModal={closeBootstrapModal}
                    //     modalData={memberDataById.data}
                    //     stateModel={stateModel}
                    // />


                    <UserDetailModal
                        toggleModal={closeBootstrapModal}
                        userData={memberDataById?.data}
                    />
                    :

                    bootstrapModalStatus === 'alert' ?
                        <>
                            {customAlertContent ?
                                <CustomAlert
                                    content={customAlertContent}
                                    toggleModal={closeBootstrapModal}
                                    handleObject={handleObject}
                                    customObjet={customObjet}
                                />
                                :
                                null}
                        </>
                        :
                        null
                }


            </ReactBootstrapModal>

        </motion.div>

    );
};

